class SliderComponent extends HTMLElement {
  constructor() {
    super();
    this.slider = this.querySelector('[id^="Slider-"]');
    this.slides = this.slider.querySelectorAll('.slider__slide');
    this.prevButton = this.querySelector('.slider-button--prev');
    this.nextButton = this.querySelector('.slider-button--next');
    this.currentPageElement = this.querySelector('.slider-counter--current');
    this.totalPagesElement = this.querySelector('.slider-counter--total');

    this.slideWidth = this.slides[0].offsetWidth;
    this.slidesPerPage = Math.floor(this.slider.offsetWidth / this.slideWidth) || 1;
    this.totalPages = Math.ceil(this.slides.length / this.slidesPerPage);
    this.currentPage = 1;

    if (this.prevButton && this.nextButton) {
      this.prevButton.addEventListener('click', this.onPrevClick.bind(this));
      this.nextButton.addEventListener('click', this.onNextClick.bind(this));
    }

    if (this.totalPagesElement) {
      this.totalPagesElement.textContent = this.totalPages;
    }

    this.updatePagination();
  }

  onPrevClick() {
    if (this.currentPage > 1) {
      this.currentPage--;
      this.slider.scrollBy({ left: -this.slider.offsetWidth, behavior: 'smooth' });
      this.updatePagination();
    }
  }

  onNextClick() {
    if (this.currentPage < this.totalPages) {
      this.currentPage++;
      this.slider.scrollBy({ left: this.slider.offsetWidth, behavior: 'smooth' });
      this.updatePagination();
    }
  }

  updatePagination() {
    if (this.currentPageElement) {
      this.currentPageElement.textContent = this.currentPage;
    }
    if (this.prevButton) {
      this.prevButton.disabled = this.currentPage === 1;
    }
    if (this.nextButton) {
      this.nextButton.disabled = this.currentPage === this.totalPages;
    }
  }
}

customElements.define('slider-component', SliderComponent);
